import React from "react";
import "./components/locale/i18n";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./assets/bootstrap/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/login/AuthConfig";
import store from "./redux/store";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundaryWrapper from "./components/errors/Fallback";
import { setupAxiosInterceptors } from "./webapi/errorInterceptor";

const container = document.getElementById("root");
const root = createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

// setupAxiosInterceptors();

root.render(
  // <ErrorBoundaryWrapper>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
  // </ErrorBoundaryWrapper>
);
